import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SyncAllFilesFromLinkedEasyPvProjectMutation as _SyncAllFilesFromLinkedEasyPvProjectMutation,
  SyncAllFilesFromLinkedEasyPvProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SyncAllFilesFromLinkedEasyPVProjectMutation = graphql(`
  mutation SyncAllFilesFromLinkedEasyPVProject(
    $input: SyncAllFilesFromLinkedEasyPVProjectInput!
  ) {
    syncAllFilesFromLinkedEasyPVProject(input: $input)
  }
`);

const useSyncAllFilesFromLinkedEasyPVProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _SyncAllFilesFromLinkedEasyPvProjectMutation,
    unknown,
    SyncAllFilesFromLinkedEasyPvProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: SyncAllFilesFromLinkedEasyPvProjectInput) => {
      return gqlClient.request(SyncAllFilesFromLinkedEasyPVProjectMutation, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSyncAllFilesFromLinkedEasyPVProject;
